import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Styles from './MerlinIframe.styles';
import { deleteCookie, getCookie } from '@/utils/Application/cookies';
import { merlinActions } from '@/redux/modules';
import ChatSkeleton from './ChatSkeleton/ChatSkeleton';

const MerlinIframe = () => {
  const [merlinSrc, setMerlinSrc] = useState(null);
  const {
    merlinUrl, token, chatId, chatCookieName,
  } = useSelector(state => state.merlin);
  const { email, name, id } = useSelector(state => state.summary);
  const dispatch = useDispatch();

  const merlinListener = useCallback((event) => {
    const action = event && event.data;
    if (typeof action === 'string') {
      const rules = {
        'close-chat': () => {
          setMerlinSrc(null);
          dispatch(merlinActions.merlinReset());
          deleteCookie(chatCookieName);
        },
      };
      action && rules[action] && rules[action]();
    }
  }, [chatCookieName, dispatch]);

  const handleMerlin = useCallback(() => {
    dispatch(merlinActions.requestMerlinToken());
  }, [dispatch]);

  const setMerlinToken = useCallback(() => {
    if (name && email && id && chatId && token) {
      const url = `https://tools.gomerlin.com.br/popup/${chatId}?name=${name}&email=${email}&userId=${id}&token=${token}`;
      setMerlinSrc(url);
      dispatch(merlinActions.merlinSetUrl(url));
    }
  }, [name, email, id, chatId, token, dispatch]);

  useEffect(() => {
    if (!token) {
      handleMerlin();
    }

    window.addEventListener('message', event => merlinListener(event));

    return () => {
      window.removeEventListener('message', event => merlinListener(event));
    };
  }, [
    merlinListener,
    handleMerlin,
    token,
  ]);

  useEffect(() => {
    const chatCookie = getCookie(chatCookieName);

    if (chatCookie && !merlinUrl && chatId && chatCookieName) {
      setMerlinToken();
    }
  }, [merlinUrl, chatId, setMerlinToken, chatCookieName]);

  return (
    merlinSrc && (
    <Styles.MerlinWrapper $showIframe={merlinSrc}>
      <Styles.Merlin src={merlinSrc} title="merlin" />
      <ChatSkeleton />
    </Styles.MerlinWrapper>
    )
  );
};

export default MerlinIframe;
